import { Record as record } from 'immutable';
import _ from 'lodash';

import validators from '../../../../src/validation';
import ValidationMixin from '../../../../src/records/ValidationMixin';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, fields } from '../../../../src/helpers/LinkMapper';

const fieldSchema = {
    "email": [ fields.string ],
    "passcode": [ fields.string ],
    "photocardNumber": [ fields.string ]
};

export default class CompensationWhitelistCustomer extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(CompensationWhitelistCustomer, json, getResolvers(fieldSchema));
    }

    getSchema () {
        const hasPhotocardNumber = _.isString(this.photocardNumber) && this.photocardNumber.length;
        return {
            email: validators.email(),
            passcode: validators.requiredString(4, 20),
            photocardNumber: hasPhotocardNumber ? validators.requiredString(3, 20) : validators.optional()
        };
    }
}

Object.assign(CompensationWhitelistCustomer.prototype, ValidationMixin);
